import {IDischargeModel} from '../api/api.types';
import {OnChanges, IChangeIndication} from '../common/common.types';
import {getDischargeValue} from './utils';
import {IHydrologicalNumberFormatter} from '../utils/hydrological-number.formatter';

interface DischargeTableRow {
  decade:number,
  dischargeValues:Array<string>
}

export default class DischargeTableController implements OnChanges {
  static $inject = ['$filter'];
  static DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  dischargeModel:IDischargeModel;
  maxX:number;
  minX:number;
  tableRows:Array<DischargeTableRow>;

  private dischargeNumberFormatter:IHydrologicalNumberFormatter;

  constructor($filter:ng.IFilterService) {
    this.dischargeNumberFormatter = $filter<IHydrologicalNumberFormatter>(
        'hydroNumberFormatter');
  }

  get digits() {
    return DischargeTableController.DIGITS;
  }

  $onChanges(changes:IChangeIndication):void {
    const lowerX = Math.floor(this.minX / 10) * 10;
    const upperX = Math.ceil(this.maxX / 10) * 10;
    this.tableRows = [];
    for (let x = lowerX; x < upperX; x += 10) {
      let row:DischargeTableRow = {
        decade: x,
        dischargeValues: []
      };
      this.tableRows.push(row);
      for (let d = 0; d < 10; ++d) {
        row.dischargeValues.push(
            this.dischargeNumberFormatter(
                getDischargeValue(x + d, this.dischargeModel)));
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/table.controller.ts
 **/